var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-select-menu-with-label relative",
      class: _vm.selectStyle === "alternative" ? "w-auto" : "w-full",
    },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center",
          class: { "flex-col": _vm.selectStyle === "alternative" },
        },
        [
          _c(
            "div",
            {
              class: [
                _vm.infoHeading || _vm.infoText ? "" : "w-14",
                {
                  "flex justify-center items-center":
                    _vm.selectStyle === "alternative",
                },
              ],
            },
            [
              _c(
                "label",
                {
                  staticClass: "text-xxs font-semibold uppercase truncate",
                  class: {
                    "text-theme": _vm.themed,
                    "text-black": !_vm.themed,
                  },
                },
                [_vm._v(_vm._s(_vm.label))]
              ),
              _vm._v(" "),
              _vm.infoHeading || _vm.infoText
                ? _c("ButtonInfo", {
                    staticClass: "ml-2",
                    attrs: {
                      themed: "",
                      heading: _vm.infoHeading,
                      body: _vm.infoText,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "v-select-menu-with-label__el relative block w-full bg-transparent appearance-none rounded-none z-20 text-lg py-2",
              class: {
                "text-theme": _vm.themed,
                "text-black": !_vm.themed,
                "px-5": _vm.selectStyle !== "alternative",
              },
              attrs: {
                id: _vm.id,
                required: "required",
                "data-testid": _vm.testId,
              },
            },
            [
              _c("span", [
                _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }